import { Navigate, useParams } from 'react-router-dom';
import { inboundShipmentDetailPath } from '@utility/utils/shipment-display';

/** Legacy `/app/shipments/:id` → inbound detail. */
export function InboundShipmentDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={inboundShipmentDetailPath(id)} replace />;
}
